import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { BoxMessage } from '../../models/boxmessage';

//config
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-startup',
  templateUrl: './startup.component.html',
  styleUrls: ['./startup.component.scss']
})

export class StartupComponent extends BaseComponent implements OnInit {

  ngOnInit(): void {
    // super.ngOnInit();
    var router = this.router;
    var localSession = this.localSession;
    var boxService = this.boxService;

    if (!localSession.isInitialized()) {
      boxService
        .getMessages()
        .subscribe((msg: BoxMessage) => { });

      localSession.init();
      boxService.setActualPage('init');
      boxService.getDeviceInfo();
    }

    setTimeout(function(){
      if (!localSession.isSocketConnected()) {
        router.navigate(['/']);
        boxService.setActualPage('error');
      }else{
        router.navigate(['/IdleStateComponent']);
        boxService.setActualPage('idle');
      }
    }, environment.socketIO.timeout);
  	
  }
}
